import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2MutationResult,
  IIndirectTaxFilingV2SendApprovalMailParams,
  IIndirectTaxFilingV2SendApprovalMailResponse,
} from './types';

export async function sendIndirectTaxFilingApprovalMail({
  params,
  token,
}: {
  params: IIndirectTaxFilingV2SendApprovalMailParams;
  token?: string;
}): Promise<
  IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2SendApprovalMailResponse>
> {
  try {
    const response = await fetcher(
      'new-sales-tax/filings-v2/approval-request',
      { method: 'POST', body: params },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to send approval mail',
      };
    }
    const data: IIndirectTaxFilingV2SendApprovalMailResponse = json;
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to send approval mail',
    };
  }
}
